import React, { useEffect } from 'react'
import { Box, Fab, Button, Grid, TextField, Typography, FormControl, Divider, Card, CardContent } from "@mui/material";
import { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import PoprchModal from "../payment/popSearch";
import { ToDate } from "../../common/toDate";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { format } from 'date-fns';
import { addVendor, getVendors } from "./vendorRegistrationApi.js"
import { addNewVendor, getVendorList } from './vendorRegistrationCustomApiHandler.js';
import { swalAlertPopProps } from "../../utils/commonUtils";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import AddIcon from "@mui/icons-material/Add";
import AddVendorForm from './addVendorForm.jsx';



export const VendorRegistration = ({ gridSize }) => {
    const [open, setOpen] = useState()
    const [modalData, setModalData] = useState()
    const [vendorsList, setVendorsList] = useState([])

    const cardKit = [
        {
            key: "vendorId",
            label: "Vendor ID"
        },
        {
            key: "vendorName",
            label: "Vendor Name"
        },
        {
            key: "companyAddress",
            label: "Company Address"
        },
        {
            key: "mobileNumber",
            label: "Mobile Number"
        }
    ]

    const getVendorsList = async () => {
        await getVendorList(getVendors, setVendorsList)
    }

    useEffect(() => {
        getVendorsList()
    }, [])

    return (
        <Grid container sx={{ padding: "12px" }}>
            <DynamicBreadcrumbs />

            <Grid item xs={12}
                sx={{
                    display: 'flex',
                    justifyContent: 'right',
                    alignItems: "center"
                }}

            >     <Fab
                onClick={() => {
                    // setOpen(true);
                    setModalData({})
                    setOpen(true);
                }}
                sx={{
                    textTransform: "capitalize",
                    width: {
                        xs: "100%",
                        sm: "auto",
                    },
                    // p: "10px",
                    whiteSpace: "nowrap",
                }}
                size="small"
                color="primary"
                variant="extended"
                aria-label="add"
            >
                    Add Vendor
                    <AddIcon />
                </Fab>
            </Grid>

            <Divider
                sx={{
                    width: "100%",
                    mt: 2,
                    background: (theme) => theme.palette.primary.main,
                }}
            />

            <Grid container>
                <Grid container item xs={12}>
                    {vendorsList && vendorsList.map((vendor) => (

                        <Grid
                            item
                            xs={gridSize ? (gridSize.xs) : 12}



                            sm={gridSize ? (gridSize.sm) : 4}

                            // md={12}
                            // lg={6}
                            key={vendor.vendorId}
                            sx={{ p: "10px", borderRight: "3px solid #dfdfdf" }}
                        >
                            <Card
                                sx={{
                                    width: "100%",
                                    // m: "0px",
                                    // mt: "10px",
                                    ":hover": {
                                        bgcolor: "#2892ba17",
                                    },
                                    cursor: "pointer",
                                    // p: "0rem 0.3rem",
                                }}
                                onClick={() => {
                                    setModalData(vendor)
                                    setOpen(true);
                                }}
                            >
                                <CardContent sx={{ padding: "0.5px 10px !important", margin: "10px" }}>
                                    {cardKit.map((row, index) => (
                                        <Grid container key={index}>
                                            <Grid item xs={6}>
                                                <Typography
                                                    sx={{
                                                        fontSize: "15px",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: "1",
                                                        WebkitBoxOrient: "vertical",
                                                    }}
                                                >
                                                    {row.label}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography
                                                    color="secondary"
                                                    sx={{
                                                        fontSize: "15px",
                                                        overflow: "hidden",
                                                        color: row?.color || "",
                                                    }}
                                                >
                                                    {vendor?.[row.key] ?? "N/A"}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    ))}
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Grid>

            <AddVendorForm
                open={open}
                setOpen={setOpen}
                modalData={modalData}
                getVendorsList={getVendorsList}
            />
        </Grid >
    )
}

